<template>
  <div class="page">
    <v-container fluid>
      <v-form ref="form" @submit.prevent="buscarCalendario">
        <v-row class="d-flex justify-center mt-3">
          <v-col cols="3">
            <v-text-field
              label="Nome do Calendário"
              v-model="form.filters.nomeCalendario"
              outlined
              dense
              hide-details
              @keyup.enter="buscarCalendario"
            ></v-text-field>
          </v-col>
          <v-col cols="3">
            <v-text-field
              label="Ano"
              v-model="form.filters.ano"
              outlined
              v-only-number
              dense
              hide-details
              @keyup.enter="buscarCalendario"
            ></v-text-field>
          </v-col>
          <sca-select-ativo
            :cols="3"
            :config="{ labelAtivo: 'Ativo', labelInativo: 'Inativo', label: 'Situação' }"
            v-model="form.filters.ativo"
            @enter="buscarCalendario"
          ></sca-select-ativo>
        </v-row>
        <div class="text-center">
          <v-col cols="12">
            <sca-submit-button></sca-submit-button>
            <sca-tooltip
              :text="'Limpar'"
              :icon="'mdi-eraser'"
              @click="resetForm()"
            ></sca-tooltip>
            <sca-tooltip
              :text="'Incluir'"
              :icon="'mdi-plus'"
              @click="openDialogManterCalendario()"
            ></sca-tooltip>
          </v-col>
        </div>
      </v-form>
      <v-data-table
        class="mt-5"
        :headers="table.headers"
        :items="table.itens"
        :items-per-page="10"
        :footer-props="$footerProps"
        no-data-text="Não há registros a serem exibidos."
      >
        <template v-slot:[`item.situacao`]="{ item }">
          <sca-label-ativo :ativo="item.situacao" :config="{ labelAtivo: 'Ativo', labelInativo: 'Inativo' }"></sca-label-ativo>
        </template>
        <template v-slot:[`item.acoes`]="{ item }">
          <sca-tooltip
            :text="'Gerenciar Calendário'"
            :icon="'mdi-calendar'"
            :small="true"
            @click="openDialogGerenciarCalendario(item)"
          ></sca-tooltip>
          <sca-tooltip
            :text="'Visualizar'"
            :icon="'mdi-eye-outline'"
            :small="true"
            @click="openDialogVisualizarCalendario(item)"
          ></sca-tooltip>
          <sca-tooltip
            :text="'Editar'"
            :icon="'mdi-pencil'"
            :small="true"
            @click="openDialogManterCalendario(item)"
          ></sca-tooltip>
          <sca-tooltip
            :text="`${item.situacao ? 'Inativar' : 'Ativar'}`"
            :icon="`${item.situacao ? 'mdi-toggle-switch-off' : 'mdi-toggle-switch'}`"
            :small="true"
            @click="inativarAtivarCalendario(item)"
          ></sca-tooltip>
        </template>
      </v-data-table>
    </v-container>
    <CadastrarEditarCalendarioDialog
      :visible="dialogManterCalendario.visible"
      :content="dialogManterCalendario.content"
      :edit="dialogManterCalendario.edit"
      @onClose="dialogManterCalendario.close()"
      @onSave="buscarCalendario()"
    ></CadastrarEditarCalendarioDialog>
  </div>
</template>

<script>
import { Dialog } from '~/commons/classes/dialog';
import { Calendario } from '~/commons/classes/calendario';
import CalendarioService from '~/services/calendario.service';
import datatablesMixin from '~/mixins/datatables.mixin';
import CadastrarEditarCalendarioDialog from "./dialogs/CadastrarEditarCalendarioDialog.vue";

export default {
  name: "ManterCalendarioView",
  mixins: [CalendarioService, datatablesMixin],
  components: {
    CadastrarEditarCalendarioDialog,
  },
  data: () => ({
    dialogManterCalendario: Dialog.Build(),
    form: {
      filters: {
        nomeCalendario: null,
        ano: null,
        ativo: null,
      },
      isLoading: false,
    },
    table: {
      headers: [
        { text: 'Nome', align: 'center', value: 'nome' },
        { text: 'Ano do Calendário', align: 'center', value: 'anoCalendario' },
        { text: 'Período', align: 'center', value: 'periodo' },
        { text: 'Situação', align: 'center', value: 'situacao', sortable: false },
        { text: 'Ações', align: 'center', value: 'acoes', sortable: false },
      ],
      itens: [],
    },
  }),
  methods: {
    buscarCalendario() {
      if(this.$validarFormulario()) {
        this.form.isLoading = true;
         const { nomeCalendario, ano, ativo } = this.form.filters;
          const payload = {
            nomeCalendario,
            ano,
            situacao: ativo !== null ? ativo : undefined,
          };
        this.$buscarCalendario({ params: payload })
        .then(({ data }) => (this.table.itens = data.lista))
        .finally(() => this.form.isLoading = false);
      }
    },
    openDialogManterCalendario(calendario) {
      calendario
        ? this.$visualizarCalendario({id: calendario.id}).then(
          ({ data }) => this.dialogManterCalendario.open(new Calendario(data.calendario), true))
        : this.dialogManterCalendario.open(Calendario.Build());
    },
    openDialogGerenciarCalendario(item) {
      this.$router.push({
          name: 'Gerenciar Calendário – Eventos',
          params: { id: item.id},
      });
    },
    openDialogVisualizarCalendario(item) {
      this.$router.push({
        name: 'Gerenciar Calendário – Eventos',
        params: { id: item.id },
        query: { isView: true }
      });
    },
    inativarAtivarCalendario(calendario) {
      this.$swal({
        text: `Deseja ${calendario.situacao ? "inativar" : "ativar"} o registro?`,
        type: "warning",
        showCancelButton: true,
        confirmButtonText: `Confirmar`,
        cancelButtonText: `Cancelar`,
      }).then(() => {
        this.$inativarAtivarCalendario(calendario.id).then(({ data }) => {
          this.$notifySuccess(data.mensagem);
          this.buscarCalendario();
        });
      });
    },
    resetForm() {
      this.table.itens = [];
      this.$clearFilters(this.form.filters);
    },
  },
};
</script>
